// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".obprompt {\n  margin-left: auto;\n  margin-right: auto;\n  color: black; }\n\n.cancel {\n  border-color: black;\n  border: solid;\n  border-width: thin;\n  color: black;\n  background-color: lightgrey; }\n\n.yes {\n  background-color: #9fd4e9;\n  border: 1px solid #321fdb;\n  color: black; }\n\n.cancel:hover {\n  color: #0e0d0d;\n  background-color: grey;\n  border: none; }\n\n.yes:hover {\n  background-color: #321fdb;\n  color: white; }\n", ""]);
// Exports
module.exports = exports;
